import { useState } from 'react';
import { Button, Dialog, DialogContent, FormField, Input } from '@proerp/ui';
import { apiRequest } from '@/lib/apiClient';
import { useToasts } from '@/lib/toast';

/** Passwort-Änderung (eigener Login, ADR 0012) — genutzt vom Benutzermenü. */
export function ChangePasswordDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const push = useToasts((state) => state.push);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [isPending, setIsPending] = useState(false);

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        if (value) {
          setCurrent('');
          setNext('');
        }
        onOpenChange(value);
      }}
    >
      <DialogContent
        title="Passwort ändern"
        footer={
          <>
            <Button variant="ghost" onClick={() => onOpenChange(false)}>
              Abbrechen
            </Button>
            <Button
              variant="primary"
              disabled={!current || next.length < 10}
              isLoading={isPending}
              onClick={async () => {
                setIsPending(true);
                try {
                  await apiRequest<void>('/v1/auth/change-password', {
                    method: 'POST',
                    body: JSON.stringify({ currentPassword: current, newPassword: next }),
                  });
                  push('success', 'Passwort geändert.');
                  onOpenChange(false);
                } catch (error) {
                  push('danger', error instanceof Error ? error.message : 'Ändern fehlgeschlagen.');
                } finally {
                  setIsPending(false);
                }
              }}
            >
              Speichern
            </Button>
          </>
        }
      >
        <div className="flex flex-col gap-4">
          <FormField label="Aktuelles Passwort" htmlFor="pwCurrent" required>
            <Input
              id="pwCurrent"
              type="password"
              autoComplete="current-password"
              value={current}
              onChange={(event) => setCurrent(event.target.value)}
            />
          </FormField>
          <FormField label="Neues Passwort" htmlFor="pwNext" required hint="Mindestens 10 Zeichen.">
            <Input
              id="pwNext"
              type="password"
              autoComplete="new-password"
              value={next}
              onChange={(event) => setNext(event.target.value)}
            />
          </FormField>
        </div>
      </DialogContent>
    </Dialog>
  );
}

